<template>
  <div class="accordion-collapse">
    <div class="accordion-body">
      <div class="owl-carousel gallery-slider owl-theme">
        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
          <Slide v-for="record in Booking_Modal" :key="record.id">
            <div>
              <img
                class="img-fluid"
                alt="Gallery"
                :src="require(`@/assets/img/gallery/gallery4/${record.Image}`)"
              />
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Booking_Modal from "@/assets/json/booking-modal.json";
export default {
  data() {
    return {
      Booking_Modal: Booking_Modal,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
};
</script>
